import { Editor } from "@tiptap/react";
import { Box } from "@mui/material";
import AppButton from "../../components/AppButton";
import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatBoldIcon from "@mui/icons-material/FormatBold";

import HeadingSelector from "./Buttons/HeadingSelector";
import AlignSelector from "./Buttons/AlignSelector";
import LinkButton from "./Buttons/LinkButton";

export const buttonSx = {
  minWidth: 0,
  px: 1,
  textTransform: "none",
  backgroundColor: "button.tonalBackground",
  color: "text.primary",
  boxShadow: "unset",
  "&:hover": { backgroundColor: "button.tonalBackgroundHover" },
};

const EditorToolbar = ({ editor }: { editor: Editor }) => {
  return (
    <Box
      sx={(theme) => ({
        margin: 0,
        padding: 0.5,
        borderBottom: `1px solid ${theme.vars.palette.divider}`,
      })}
    >
      <Box
        sx={{
          display: "flex",
          gap: 1,
        }}
      >
        <HeadingSelector editor={editor} />
        <AppButton
          intent="secondary"
          onClick={() => editor.chain().focus().toggleBold().run()}
          sx={buttonSx}
        >
          <FormatBoldIcon />
        </AppButton>

        <AppButton
          intent="secondary"
          onClick={() => editor.chain().focus().toggleItalic().run()}
          sx={buttonSx}
        >
          <FormatItalicIcon />
        </AppButton>
        <AppButton
          intent="secondary"
          sx={buttonSx}
          onClick={() => editor.chain().focus().toggleUnderline().run()}
        >
          <FormatUnderlinedIcon fontSize="small" />
        </AppButton>
        <AlignSelector editor={editor} />
        <LinkButton editor={editor} />
        <AppButton
          intent="secondary"
          onClick={() => editor.chain().focus().undo().run()}
          sx={buttonSx}
        >
          <UndoIcon />
        </AppButton>
        <AppButton
          intent="secondary"
          onClick={() => editor.chain().focus().redo().run()}
          sx={buttonSx}
        >
          <RedoIcon />
        </AppButton>
      </Box>
    </Box>
  );
};

export default EditorToolbar;
